import Vue from "vue"
import Vuex from "vuex"
import { getField, updateField } from "vuex-map-fields"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    addLocationdialog: false,
    snackBarMessage: "",
    snackBar: false,
    snackBarcolor: "warning",
    user: null,
    isAuthenticated: false,
    settings: [],
    currentCount: 0,
    imageURL: null,
    monitorSize: [
      "14",
      "14.1",
      "15",
      "17",
      "17",
      "17",
      "18",
      "18.4",
      "19",
      "19",
      "20",
      "20",
      "20",
      "20.1",
      "21",
      "21.3",
      "21.5",
      "22",
      "22",
      "22",
      "22.2",
      "23",
      "23",
      "24",
      "24",
      "26",
      "27",
      "27",
      "30",
      "32",
      "40"
    ]
  },
  mutations: {
    updateField
  },
  getters: {
    getField
  }
})
